import { createClient } from '@supabase/supabase-js'


const supabaseUrl = 'https://tfbjzdntbkdpbycamrkr.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRmYmp6ZG50YmtkcGJ5Y2FtcmtyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMwOTQ3OTEsImV4cCI6MjA4ODY3MDc5MX0.XvQnCRnC650PO1At25jBGMFaHry4HPLv9fOv3SZaias'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
